export default function getArray(items) {
  if (!items) return [];
  return Array.isArray(items) ? items : [items];
}
